import styled, { css, DefaultTheme } from 'styled-components';
import media from 'styled-media-query';
import { SubTitle, Heading } from 'components/structure';
import * as LogoStyles from 'components/structure/Logo/Logo.styles';

type CountdownText = {
  isActive?: boolean;
};

const containerModifiers = {
  hasMemberGetMember: (theme: DefaultTheme) => css`
    ${media.greaterThan('large')`
      min-height: 100%;
      height: calc(100vh - ${'80px'});
      overflow-y: auto;
    `}

    ${media.lessThan('large')`
      ${Content} {
        padding-top: ${theme.spacing.xl};
      }

      > svg {
        display: none;
      }
    `}
  `,
};

export const Container = styled.div<{ hasMemberGetMember?: boolean }>`
  ${({ theme, hasMemberGetMember }) => css`
    background: url(${theme.countdown.background.image}) no-repeat center;
    background-size: cover;
    display: flex;

    flex-direction: column;
    justify-content: space-between;
    height: 100vh !important;
    min-height: 100vh;
    /* height: auto; */
    /* height: calc(100vh - ${'80px'}); */
    width: 100%;
    padding: ${theme.spacing.lg} ${theme.spacing['2xl']};

    ${media.lessThan('large')`
      padding: ${theme.spacing.xl} ${theme.spacing.md} ${theme.spacing.md};
      height: 100% !important;


      ${LogoStyles.Wrapper} {
        margin-bottom: 0;
      }
    `}

    ${SubTitle} {
      color: ${theme.text.secondary};
    }

    ${hasMemberGetMember && containerModifiers.hasMemberGetMember(theme)}
  `}
`;
export const LogoContainer = styled.main`
  position: absolute;
  top: 32px;
  left: 64px;
  bottom: 0px;
  ${media.lessThan('medium')`
    display: none;
  `}
`;

export const Content = styled.main`
  ${({ theme }) => css`
    flex: 1;
    height: 100%;
    display: flex;
    background-color: rgb(35, 32, 32, 75);
    flex-direction: column;
    /* align-items: center; */
    /* justify-content: center; */
    /* margin-bottom: ${theme.spacing['2xl']}; */

    > h3 {
      &:not(:last-child) {
        margin-bottom: 0px;
      }
    }
    ${media.greaterThan('large')`
     align-items: center;
    justify-content: center;
     /* margin-bottom: ${theme.spacing['2xl']}; */
    `}

    ${media.lessThan('medium')`
      text-align: center;
      /* margin-bottom: ${theme.spacing.lg}; */
    `}
  `};
`;
export const Card = styled.main`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.15); */
    background: ${theme?.countdown?.background.card
      ?.background}; // background: 'rgba(255, 255, 255, 0.2)',
    border-radius: 16px;
    backdrop-filter: blur(
      ${theme?.countdown?.background?.card?.filterBlur}
    ); // filterBlur: '16px',
    padding: 8px 0 0;
    margin: 60px 0 0px;

    ${media.lessThan('medium')`
      margin: 0px 0 30px;

  `}

    ${media.greaterThan('huge')`
      padding: 48px 24px ;

  `}
  `};
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-size: 64px;
    margin-bottom: ${theme.spacing.sm};
    text-align: center;
    width: 641px;

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.xl};
      line-height: 40px;
      margin-top: ${theme.spacing.md};
      width: auto;
    `}
  `}
`;

export const TitleTwo = styled.h2`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-size: 1.5rem;
    margin-bottom: ${theme.spacing.sm};
    text-align: center;
    width: 642px;
    padding: 0 1rem;

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.md};
      // line-height: 40px;
      margin-top: ${theme.spacing.md};
      width: auto;
    `}
  `}
`;
export const WaitingTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-weight: 700;
    font-size: 64px;

    ${media.lessThan('medium')`
      font-size: 24px;

      margin-top: 8px;;
      width: auto;
    `}
  `}
`;

export const WaitingDots = styled.span`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-weight: 700;
    font-size: 64px;

    ${media.lessThan('medium')`
      font-size: 24px;

      margin-top: 8px;
      width: auto;
    `}
  `}
`;

export const TitleEnd = styled.h2`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-size: 1.5rem;
    margin-bottom: ${theme.spacing.sm};
    margin-top: -10px;
    text-align: center;
    width: 100%;

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.md};
      line-height: 40px;
      margin-top: -10px;
      width: auto;
    `}
  `}
`;

export const FooterDescription = styled.h2`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-size: 16px;
    margin-bottom: ${theme.spacing.sm};
    font-weight: 400;
    text-align: center;
    width: 450px;

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.sm};
      line-height: 20px;
      margin-top: ${theme.spacing.md};
      width: auto;
    `}
  `}
`;

export const WaitingStart = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: black;
    padding: 2rem;
    h1 {
      font-size: 64px;
    }
    h2 {
      font-size: 32px;
    }
    h3 {
      font-size: 64px;
      width: 45px;
      text-align: start;
    }
  `}
`;
export const CountdownContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${theme.spacing.lg};
    width: 100%;

    ${media.lessThan('large')`
      flex-wrap: wrap;
    `}

    ${media.lessThan('small')`
      flex-direction:column;
    `}
  `}
`;

const textModifiers = {
  isActive: (theme: DefaultTheme) => css`
    ${CountText}, ${PeriodText} {
      color: ${theme.countdown.color};
    }
  `,
};

export const CurrentTimeContainer = styled.div<CountdownText>`
  font-size: 12px;
  ${({ theme, isActive }) => css`
    padding: 0 ${theme.spacing.xl};
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    word-break: break-all;

    ${media.lessThan('medium')`
      margin-bottom: ${theme.spacing.sm};
    `}

    ${isActive && textModifiers.isActive(theme)}
  `}
`;

export const CountText = styled.h1`
  ${({ theme }) => css`
    color: ${theme.countdown.color} !important;
    font-size: calc(${theme.typography.sizes['4xl']} * 2);
    font-weight: normal;

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes['4xl']};
      line-height: 64px;
      font-weight: 700;
    `}
  `}
`;

export const PeriodText = styled.h3`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    letter-spacing: 10px;
    margin-top: ${theme.spacing.sm};

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.sm};
      line-height: ${theme.typography.lineHeight.base};
      font-weight: 700;
      text-align: center;
      margin-top: 0;
      margin-left: 10px;
    `}
  `}
`;

export const CountdownFooter = styled.footer`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    //margin-top: 20px;

    > small {
      text-align: center;
      color: ${theme.text.primary};
      max-width: 420px;
      margin-top: ${theme.spacing.sm};
    }
  `}
`;

export const SocialLinksContainer = styled.div`
  ${({ theme }) => css`
    margin-top: 160px;
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacing.sm};
    ${media.lessThan('medium')`

      flex-direction: column;
      margin-top: 50px;
    `}
    > strong {
      color: ${theme.countdown.color};
      margin-right: ${theme.spacing.sm};
    }

    > p {
      margin-bottom: 0;
    }
  `}
`;

export const SocialLinksList = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    margin-left: 20px;

    a {
      color: ${theme.text.primary};
      margin-right: 20px;
    }

    svg {
      color: ${theme.text.primary};
      width: 18px;
      height: 18px;
    }
  `}
`;

export const Footer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${theme.secondary};
    height: ${'80px'};
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 ${theme.spacing.lg};

    > svg {
      display: none;
    }

    ${media.lessThan('large')`
      top: 0;
      padding: 0 ${theme.spacing.md};

      > svg {
        width: 80px;
        display: block;
      }
    `}
  `}
`;

export const Aside = styled.aside`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    > svg {
      cursor: pointer;
      color: ${theme.countdown.color};
    }

    ${Heading} {
      margin-bottom: 0;
      margin-left: ${theme.spacing.lg};
      font-size: ${theme.typography.sizes.lg};
    }

    ${media.lessThan('large')`
      > svg {
        width: 14px;
        height: 14px;
      }

      ${Heading} {
        font-size: ${theme.typography.sizes.sm};
        margin-left: ${theme.spacing.sm};
      }
    `}
  `}
`;

export const FooterTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-size: 1rem;
    font-weight: 700;
    margin-top: 10px;
  `}
`;

export const Paragraph = styled.p`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-size: ${theme.typography.sizes.base};
    font-weight: 400px;
    line-height: 24px;
    text-align: center;
    position: absolute;
    width: 434px;
    height: 48px;
    left: 35%;
    top: 80%;

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.xs};
      line-height: 24px;
      position: absolute;
      width: 287px;
      height: 72px;
      left: calc(50% - 287px/2);
      top:90%;

      @media (max-width: 375px){
        width: 280px;
        height: 50px;
        top:100%;
      }
    `}
  `}
`;

export const CreatorWeekBr = styled.h5`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  position: absolute;
  width: 135px;
  left: 730px;
  top: 743px;
  ${media.lessThan('medium')`
  left: 30%;
  top: 780px;
  `};
  ${media.lessThan('large')`
  left: 600px;
  `};
`;

export const ContentTitle = styled.div`
  display: inline;
  text-align: center;
  width: 80%;
  margin-top: 45px;
  ${media.lessThan('medium')`
      margin-left:10px ;
  `}
`;

export const Link = styled.a`
  ${({ theme }) => css`
    color: ${theme.countdown.color};
    font-size: 22px;
    font-weight: bold;
    text-decoration: underline;

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.md};
      line-height: ${theme.typography.lineHeight.base};
    `}
  `}
`;

export const ContentFooter = styled.div`
  display: inline;
`;
